import React from "react";
import prod1 from "../images/clients/product/p1.png";
import prod2 from "../images/clients/product/p2.png";
import prod3 from "../images/clients/product/p3.png";
import prod4 from "../images/clients/product/p4.png";
import prod5 from "../images/clients/product/p5.png";
import prod6 from "../images/clients/product/p6.png";
import prod7 from "../images/clients/product/p7.png";
import prod8 from "../images/clients/product/p8.png";

const Portfolio = () => {
  return (
    <>
      <div className="my-4 py-4" id="portfolio">
        <h2 className="my-2 text-center text-3xl text-[#2f337c] uppercase font-bold">
          Products
        </h2>
        <div className="flex justify-center">
          <div className="w-24 border-b-4 border-blue-900 mb-8"></div>
        </div>

        <div className="px-4" data-aos="fade-down" data-aos-delay="600">
          <div className="mb-4 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden hover:scale-105 rounded-lg shadow-md h-[300px] w-auto flex justify-center items-center">
              <img
                alt="card img"
                className="object-cover h-full w-auto rounded-lg"
                src={prod1}
              />
            </div>

            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden hover:scale-105 rounded-lg shadow-md h-[300px] w-auto flex justify-center items-center">
              <img
                alt="card img"
                className="object-cover h-full w-auto rounded-lg"
                src={prod2}
              />
            </div>

            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden hover:scale-105 rounded-lg shadow-md h-[300px] w-auto flex justify-center items-center">
              <img
                alt="card img"
                className="object-cover h-full w-auto rounded-lg"
                src={prod3}
              />
            </div>

            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden hover:scale-105 rounded-lg shadow-md h-[300px] w-auto flex justify-center items-center">
              <img
                alt="card img"
                className="object-cover h-full w-auto rounded-lg"
                src={prod4}
              />
            </div>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden hover:scale-105 rounded-lg shadow-md h-[300px] w-auto flex justify-center items-center">
              <img
                alt="card img"
                className="object-cover h-full w-auto rounded-lg"
                src={prod5}
              />
            </div>

            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden hover:scale-105 rounded-lg shadow-md h-[300px] w-auto flex justify-center items-center">
              <img
                alt="card img"
                className="object-cover h-full w-auto rounded-lg"
                src={prod6}
              />
            </div>

            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden hover:scale-105 rounded-lg shadow-md h-[300px] w-auto flex justify-center items-center">
              <img
                alt="card img"
                className="object-cover h-full w-auto rounded-lg"
                src={prod7}
              />
            </div>

            <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden hover:scale-105 rounded-lg shadow-md h-[300px] w-auto flex justify-center items-center">
              <img
                alt="card img"
                className="object-cover h-full w-auto rounded-lg"
                src={prod8}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
